import { UserProvider } from './UserContext';
import { AuthProvider } from './AuthContext';
import { CreditsProvider } from './CreditsContext';
import { AnalysisProvider } from './AnalysisContext';
import { SwingHistoryProvider, useSwingHistoryContext } from './SwingHistoryContext';
import { useDeviceId } from '../hooks/useDeviceId';
import { useInit } from '../hooks/useInit';

// Inner component that has access to SwingHistoryContext
function InnerProviders({ children }) {
  const { swingHistory, saveSwingToHistory } = useSwingHistoryContext();

  return (
    <AnalysisProvider
      swingHistory={swingHistory}
      saveSwingToHistory={saveSwingToHistory}
    >
      {children}
    </AnalysisProvider>
  );
}

export function AppProviders({ children }) {
  const deviceId = useDeviceId();
  const initData = useInit(deviceId);

  // Show loading only briefly while getting deviceId (instant from localStorage)
  // Don't wait for API - render immediately with loading states
  if (!deviceId) {
    return (
      <div className="min-h-screen bg-black text-white flex items-center justify-center">
        <div className="text-emerald-400 text-lg">Loading...</div>
      </div>
    );
  }

  return (
    <UserProvider deviceId={deviceId} initData={initData}>
      <AuthProvider initData={initData}>
        <CreditsProvider initData={initData}>
          <SwingHistoryProvider>
            <InnerProviders>
              {children}
            </InnerProviders>
          </SwingHistoryProvider>
        </CreditsProvider>
      </AuthProvider>
    </UserProvider>
  );
}

// Re-export all hooks for convenient access
export { useUser } from './UserContext';
export { useAuthContext } from './AuthContext';
export { useCreditsContext } from './CreditsContext';
export { useAnalysisContext } from './AnalysisContext';
export { useSwingHistoryContext } from './SwingHistoryContext';
